export const getConfig = (id) => {
  const config =  {
    fieldControl: false,
    tableType: 'antd',
    scroll: {x: '100%'},
    columns: [
      {
        title: '分类/项目/通项/子项',
        width: 200,
        dataIndex: 'dtlName',
        render:(text)=><p>{text}</p>
      },
      {
        title: '类型',
        width: 120,
        dataIndex: 'busTypeName',
      },
      {
        title: '适用门店',
        width: 200,
        dataIndex: ['shopList'],
        render: 'companyRender',
      },
      {
        title: '创建人',
        width: 200,
        dataIndex: 'createdByName',
      },
      {
        title: '创建时间',
        width: 180,
        dataIndex: 'createdTime',
        itemType: 'dateTime',
      },
      {
        title: '操作',
        dataIndex: '#',
        render: 'actionRender',
        fixed: 'right',
        width: 210,
      },
    ],
    footer: [
      {
        label: '添加分类',
        type: 'primary',
        disabled: 'topLevelIsCate',
        events: ['onClick:onAddCategory'],
      },
      {
        label: '添加项目',
        type: 'primary',
        disabled: 'topLevelIsProject',
        events: ['onClick:onAddProject'],
      },
      {
        label: '添加通项',
        type: 'primary',
        disabled: 'topLevelIsGeneral',
        events: ['onClick:onAddGeneral'],
      },
      {
        label: '添加子项',
        type: 'primary',
        disabled: 'topLevelIsProject',
        events: ['onClick:onAddChild'],
      },
      {
        label: '下载导入配置',
        render: 'downloadRender',
      },
      {
        label: '导出',
        type: 'primary',
        render: 'exportDownloadRender',
      },
    ],
    search: [
      {
        name: 'showNameKey',
        label: '分类/项目/通项/子项',
      },
    ],
    batchActions: id && [
      {
        label: '失效',
        events: ['onClick:onChangeStatus'],
      },
    ],
  }
  const columns = [...config.columns]
  if (id) {
    columns.splice(5,0, ...[
      {
        title: '失效时间',
        width: 180,
        dataIndex: 'expirationTime',
        itemType: 'dateTime',
      },
      {
        title: '状态',
        width: 120,
        dataIndex: 'isExpire',
        render: 'isExpireRender',
        fixed: 'right',
      },
    ])
  }
  return {
    ...config,
    columns,
  }
}
